module.exports = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = '/ckeditor/ckeditor.js?v=4.16.2';
        script.onload = () => {
          const proxy = {
            get: (module) => {
              return Promise.resolve(() => ({ default: window.CKEDITOR }));
            },
            init: () => {},
          };
          resolve(proxy);
        };
        script.onerror = () => {
          reject(new Error('Failed to load CKEditor script'));
        };
        document.head.appendChild(script);
      });